const gtmEventCategories = {
  COMMUNITY_DISCUSSIONS: "community_discussions",
};

const gtmEventActions = {
  CLICK_DISCUSSION_CREATE: "click_discussion_create",
  CLICK_DISCUSSION_REPLY: "click_discussion_reply",
  CLICK_DISCUSSION_TOPIC_VOTE: "click_discussion_topic_vote_",
  CLICK_DISCUSSION_REPLY_VOTE: "click_discussion_reply_vote_",
};

module.exports = { gtmEventCategories, gtmEventActions };
